import { c as _c } from "react/compiler-runtime";
import { PortableText } from "@/sanity/sanity.types";
import { ReactNode } from "react";
import Image from "@/components/common/image/image";
interface PortableTextRendererProps {
  content: PortableText;
}
const PortableTextRenderer = t0 => {
  const $ = _c(2);
  const {
    content
  } = t0;
  const renderBlock = _temp;
  let t1;
  if ($[0] !== content) {
    const groupedContent = [];
    let currentList = [];
    let currentListType = null;
    content.forEach((block_0, index_0) => {
      if (block_0._type === "block" && (block_0.listItem === "bullet" || block_0.listItem === "number")) {
        if (currentListType !== block_0.listItem) {
          if (currentList.length > 0) {
            groupedContent.push(currentListType === "bullet" ? <ul key={`list-${index_0}`} className="mb-4">{currentList.map((item, i) => renderBlock(item, i))}</ul> : <ol key={`list-${index_0}`} className="mb-4 list-decimal pl-6">{currentList.map((item_0, i_0) => renderBlock(item_0, i_0))}</ol>);
          }
          currentList = [block_0];
          currentListType = block_0.listItem;
        } else {
          currentList.push(block_0);
        }
      } else {
        if (currentList.length > 0) {
          groupedContent.push(currentListType === "bullet" ? <ul key={`list-${index_0}`} className="mb-4">{currentList.map((item_1, i_1) => renderBlock(item_1, i_1))}</ul> : <ol key={`list-${index_0}`} className="mb-4 list-decimal pl-6">{currentList.map((item_2, i_2) => renderBlock(item_2, i_2))}</ol>);
          currentList = [];
          currentListType = null;
        }
        groupedContent.push(renderBlock(block_0, index_0));
      }
    });
    if (currentList.length > 0) {
      groupedContent.push(currentListType === "bullet" ? <ul key="final-list" className="mb-4">{currentList.map((item_3, i_3) => renderBlock(item_3, i_3))}</ul> : <ol key="final-list" className="mb-4 list-decimal pl-6">{currentList.map((item_4, i_4) => renderBlock(item_4, i_4))}</ol>);
    }
    t1 = <>{groupedContent}</>;
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PortableTextRenderer;
function _temp(block, index) {
  if (block._type === "block") {
    const children = block.children?.map((child, childIndex) => {
      if (child._type === "span") {
        let text = child.text || "";
        if (child.marks) {
          child.marks.forEach(mark => {
            if (mark === "strong") {
              text = <strong key={childIndex}>{text}</strong>;
            }
            if (mark === "em") {
              text = <em key={childIndex}>{text}</em>;
            }
          });
        }
        if (block.markDefs) {
          const linkDef = block.markDefs.find(def => child.marks?.includes(def._key));
          if (linkDef && linkDef._type === "link") {
            text = <a key={childIndex} href={linkDef.href} className="font-medium text-[#00698F] underline transition-colors hover:text-[#004d66]">{text}</a>;
          }
        }
        return text;
      }
      return null;
    });
    switch (block.style) {
      case "blockquote":
        {
          return <blockquote key={index} className="mb-4 border-l-4 border-[#069590] pl-4 italic text-[#373a36]">{children}</blockquote>;
        }
      default:
        {
          if (block.listItem === "bullet") {
            return <li key={index} className="relative mb-2 pl-10 text-[16px] leading-7 text-[#373a36] md:text-[18px]"><Image src="/checkmark.svg" alt="Checkmark" className="absolute left-0 top-1" width={24} height={24} />{children}</li>;
          }
          if (block.listItem === "number") {
            return <li key={index} className="mb-2 text-[16px] leading-7 text-[#373a36] md:text-[18px]">{children}</li>;
          }
          return <p key={index} className="mb-4 text-[16px] leading-7 text-[#373a36] md:text-[18px]">{children}</p>;
        }
    }
  }
  return null;
}